import { useHistory } from 'react-router-dom'
import { routes } from 'Routes'

import { makeStyles, Grid, Typography, Box, Button } from '@material-ui/core'
import { useAuth } from 'hooks'
import * as service from 'service'

import styles from './styles'

const useStyles = makeStyles(styles)

const Forbidden = () => {
  const classes = useStyles()
  const history = useHistory()
  const auth = useAuth()

  const handleHome = async () => {
    if (service.dponet.auth.isAuthenticated()) {
      await auth.loadPermissions()
    }
    history.push(auth.homePage || routes.root)
  }

  return (
    <Box className={classes.root}>
      <Grid container justifyContent="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <Box className={classes.content}>
            <Typography variant="h1">403: Não autorizado</Typography>
            <Typography variant="subtitle2">
              Você tentou algum caminho desconhecido ou veio aqui por engano.
              Seja qual for, tente usar a navegação
            </Typography>
            <Box mt={3}>
              <Button color="primary" variant="contained" onClick={handleHome}>
                Voltar ao início
              </Button>
            </Box>
            <img
              alt="Em desenvolvimento"
              className={classes.image}
              src="/images/forbidden.svg"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Forbidden
